import { gql, useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';

import { GET_PROCESS_BY_ID } from 'src/hooks/processes/get-process-by-id.hook';
import { GET_PROCESS_TASKS_TEMPLATES_FOR_TABLE } from './get-process-tasks-templates.hook';
import { GET_PROCESSES_WITH_PAGINATION } from 'src/hooks/processes/get-processes-with-pagination.hook';

import { IHookCallbacks } from '../common.hooks.interfaces';


export const DELETE_PROCESS_TASKS_TEMPLATE = gql`
  mutation deleteProcessTasksTemplate($processTaskTemplateId: ObjectId!) {
    deleteProcessTasksTemplate(processTaskTemplateId: $processTaskTemplateId) {
      _id
    }
  }
`;

export const useDeleteProcessTasksTemplate = ({ onSuccess }: IHookCallbacks) => {
  const { t } = useTranslation('settings');
  const [deleteProcessTasksTemplate] = useMutation(DELETE_PROCESS_TASKS_TEMPLATE, {
    onCompleted: data => {
      onSuccess();
      if (data?.deleteProcessTasksTemplate?._id) {
        showNotification({
          isIcon: false,
          type: NOTIFICATION_TYPE.success,
          message: t('processTemplates.notifications.deletedSuccessfully'),
        });
      }
    },
    onError: ({ graphQLErrors = [] }: { graphQLErrors?: any }) => {
      const [error] = graphQLErrors || [];

      return showNotification({
        isIcon: false,
        type: NOTIFICATION_TYPE.error,
        message: t('settings:userProfileSettings.error.title'),
        description: error,
      });
    },
    refetchQueries: [
      GET_PROCESS_BY_ID,
      GET_PROCESSES_WITH_PAGINATION,
      GET_PROCESS_TASKS_TEMPLATES_FOR_TABLE,
    ],
  });

  return deleteProcessTasksTemplate;
};
